import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { BORDER_BOX } from 'common';

const dividerWidth = '0.0625rem';

export default {
  Title: styled.div`
    ${BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    padding: ${Tokens.SPACING.SPACING_24} ${Tokens.SPACING.SPACING_24} ${Tokens.SPACING.SPACING_16} ${Tokens.SPACING.SPACING_24};
    overflow: hidden;
  `,
  Content: styled.div`
    overflow: auto;
    flex: 1;
    ${BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    ${props => css`border-bottom: ${props.isBottomDividerVisible ? `${dividerWidth} solid ${props.$theme.DIVIDER.color}` : 'none'};`} 
    ${props => css`border-top: ${props.isTopDividerVisible ? `${dividerWidth} solid ${props.$theme.DIVIDER.color}` : 'none'};`} 
    padding: ${Tokens.SPACING.SPACING_0} ${Tokens.SPACING.SPACING_24};
    ${props => props.isTopDividerVisible ? css`padding-top: ${Tokens.SPACING.SPACING_16};` : css``}
    ${props => props.footer ? css`` : css`padding-bottom: ${Tokens.SPACING.SPACING_24};`}
  `,
  Footer: styled.div`
    ${BORDER_BOX}
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    flex: 0;
    justify-self: end;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: ${Tokens.SPACING.SPACING_16};
    > *:not(:first-child) {
      margin-left: ${Tokens.SPACING.SPACING_8}
    }
  
  `
};
